import React from "react";
import "./Style.scss";

interface INoDetailsProps {
  title: string;
  className?: string;
  description: string;
  notFoundIcon: React.ReactNode;
  style?: React.CSSProperties;
}

export const NoDetails: React.FC<INoDetailsProps> = ({ title, description, notFoundIcon, style }) => {
  return (
    <div className="no-details-container" style={style}>
      <div className="no-details-icon">
        {notFoundIcon}
      </div>
      <div className="no-details-main-message">
        {title}
      </div>
      <div className="no-details-description">
        {description}
      </div>
    </div>
  );
};
